<template>
  <section class="till-date-range-section">
    <v-alert type="info" :value="showInfo" transition="slide-x-transition">
      Veuillez sélectionner la date pour laquelle vous effectuer la fermeture de
      la caisse.
      <br />Si la caisse n'a pas été compté depuis plusieurs jours et que vous
      avez en main seulement un relevé de TPV veuillez sélectionner les journées
      pour lesquels vous inscrivez la fermeture.
    </v-alert>
    <v-layout>
      <v-date-picker
        class="hidden-xs-only"
        :value="dates"
        @input="e => $emit('update:dates', e)"
        full-width
        landscape
        multiple
      ></v-date-picker>
      <v-date-picker
        class="hidden-sm-and-up"
        :value="dates"
        @input="e => $emit('update:dates', e)"
        full-width
        multiple
      ></v-date-picker>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-alert
          :value="salesGetter.length !== dates.length"
          type="error"
          transition="slide-y-transition"
        >
          Les ventes ne sont pas inscrites dans le système pour au moins une des
          journées sélectionnées!
          <br />
          <router-link :to="{ name: 'SalesIndex' }"
            >Aller les inscrire avant de procéder.</router-link
          >
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <v-alert
          :value="!datesValidation"
          type="error"
          transition="slide-y-transition"
          >Les jours sélectionnées ne sont pas consécutifs!</v-alert
        >
      </v-flex>
    </v-layout>
    <v-scroll-y-transition>
      <v-layout wrap v-show="salesGetter.length > 0">
        <v-flex xs12 sm6 class="mt-2">
          <v-text-field
            filled
            class="no-before"
            dense
            hide-details
            readonly
            :value="totalSales"
            :error="salesGetter.length !== dates.length"
            label="Total des ventes pour les journées sélectionnées"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-scroll-y-transition>
  </section>
</template>

<script>
import moment from "moment";
import round10 from "round10";

export default {
  name: "TillDateRange",
  props: {
    dates: {
      type: Array,
      required: true
    },
    sales: {
      type: Number,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    showInfo: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    salesGetter() {
      return this.$store.getters.getSales.filter(
        s =>
          this.dates.includes(s.date) &&
          s.store === this.$store.getters.getStoreId
      );
    },
    datesValidation() {
      const sortedDates = this.dates
        .map(d => moment(d))
        .sort((a, b) => a.diff(b));
      for (const [i, value] of sortedDates.entries()) {
        if (i !== sortedDates.length - 1) {
          const isBefore = moment
            .duration(value.diff(moment(sortedDates[i + 1])))
            .asDays();
          if (isBefore !== -1) {
            return false;
          }
        }
      }
      return true;
    },
    totalSales() {
      const total = round10.round10(
        this.salesGetter
          .map(s => Number(s.value_after_tx))
          .reduce((a, b) => a + b, 0),
        -2
      );
      this.$emit("update:sales", total);
      return total;
    },
    isValid() {
      const isValid =
        this.datesValidation &&
        this.salesGetter.length === this.dates.length &&
        this.salesGetter.length > 0;

      return isValid;
    }
  },
  watch: {
    datesValidation() {
      this.$emit("update:valid", this.isValid);
    },
    salesGetter() {
      this.$emit("update:valid", this.isValid);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/colors.scss";
.till-date-range-section {
  .section-header {
    font-size: 1.2rem;
    font-weight: bold;
    color: $tertiary;
    opacity: 0.8;
  }
}
</style>
